// extracted by mini-css-extract-plugin
export var addToCartButton = "_si-b";
export var arrowButtonContainer = "_si-9";
export var arrowButtonIcon = "_si-a";
export var carouselArrowButton = "_si-6";
export var carouselElementContainer = "_si-1";
export var galleryThumbnail = "_si-d";
export var galleryThumbnailImage = "_si-e";
export var left = "_si-7";
export var productDisplayCarouselContainer = "_si-0";
export var productTileContainer = "_si-2";
export var productTileImage = "_si-4";
export var productTileImageContainer = "_si-3";
export var productTileTitle = "_si-5";
export var right = "_si-8";
export var sliderOverflow = "_si-c";